<template>
  <div class="subcontent">
    <div class="subbanner" :style="{ backgroundImage: 'url(' + pageContent.topbanner + ')' }">
      <div class="container">
        <h1 class="title">{{ pageContent.bigadtext }}</h1>
        <span>{{ pageContent.smalladtext }}</span>
      </div>
    </div>
    <div class="mainwrap">
      <div class="container">
        <div class="submain">
          <div class="titleA"><strong>{{ pageContent.title }}</strong></div>
          <!-- <div class="textCenter"><img src="../assets/about1.png" /></div> -->
          <!-- <div v-if="pageContent" v-html="pageContent.content"></div>
          <div v-else>
            <p>页面暂无内容</p>
          </div> -->
          <div>
            <el-row>
              <el-col :span="10">
                <div class="textCenter"><img src="../assets/about2.png" style="width:100%;" /></div>
              </el-col>
              <el-col :span="14"> <p>郑州博奥润康生物科技有限公司成立于2018年，是一家专业从事基因科学研究、分子诊断技术、DNA数据库建设和测序试剂盒研发的科技型技术企业，总部位于河南省国家大学科技园区。具有独立法人资质的第三方医学检验实验室、司法鉴定中心及二、三类医疗器械、试剂研发、生产、销售为一体完整产业链的新型科技企业。</p>
 <p>公司目前拥有国内最前沿医疗设施的二级生物安全实验室、液质实验室、理化实验室、微生物培养鉴定实验室等；配备有最先进、齐全的高端分子诊断仪器(包括一代、二代测序仪；荧光定量PCR仪、质谱仪、微流控基因芯片核酸检测系统等设备)。实验室具备以基因芯片和基因测序为基础，主要开展高端特色的司法鉴定及分子诊断相关领域的检测服务；包括亲子鉴定、酒精鉴定和临床鉴定等司法鉴定项目及出生缺陷、病原感染、肿瘤防治、神经免疫、心脑血管个体化用药指导等临床检测服务。</p>
 <p>公司以生物芯片为核心技术平台，拥有研发、生产、销售以及第三方独立医学检验所服务为一体的大医学完整产业链，并响应国家关于"预防为主"的卫生健康方针，将现代医学与中国传统医学紧密结合，通过对传统中医药进行工程化和科学化提升，打造集健康产品、健康管理和医疗康复于一体的大健康产业板块。</p>
 <p>公司秉承优秀的"政、产、学、研、用"一体化理念；立足新一代生物检测技术，为司法DNA鉴定医学领域、临床医学、预防医学、健康管理和科学研究等领域客户提供高品质的产品和服务。为人民群众健康保驾护航为科技造福人类做出卓越贡献。</p>
              </el-col>
            </el-row>
            <h3><span style="background: #007bc8;"></span>服务面向对象</h3>
            <p>面向全国大型三级医院、专科医院和综合性医院，提供全面的专科特检服务，涵盖亲子鉴定、出生缺陷到肿瘤防治等临床检验项目，满足不同医疗机构的专业检测需求。</p>
            <h3><span style="background: #f08300;"></span>分子诊断技术</h3>
            <p>在分子诊断技术领域开展高端特色的检测服务，包括病原感染、肿瘤防治、心脑血管及个体化用药指导，利用前沿的分子诊断工具为临床提供准确诊断依据。</p>
            <h3><span style="background: #f08300;"></span>自身免疫疾病检测服务</h3>
            <p>通过自身免疫抗体检测平台，提供神经系统自身免疫抗体检测等服务，致力于帮助临床医生更准确地诊断自身免疫疾病，推动疾病的早期诊断和有效治疗。</p>
            <h3><span style="background: #f08300;"></span>实验室设施与设备</h3>
            <p>设有二级生物安全实验室、免疫实验室、分子实验室等，配备分子诊断仪器如二代测序仪、荧光定量PCR仪、质谱仪等，以及免疫诊断仪器包括荧光显微镜和全自动免疫印迹仪，确保检测的先进性和准确性。</p>
            <h3><span style="background: #f08300;"></span>临床检验项目</h3>
            <p>实验室提供包括亲子鉴定、出生缺陷、肿瘤防治等在内的一系列临床检验项目，以精准的检测结果辅助临床决策，提升医疗服务质量。</p>
            <h3>技术平台</h3>
            <img src="../assets/about3.png" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { pageApi } from '@/api'

export default {
  name: 'About',
  data() {
    return {
      pageContent: ''
    }
  },
  mounted() {
    // 使用固定的ID查询，例如ID为1的页面
    this.fetchAboutPage(1)
  },
  methods: {
    async fetchAboutPage(pageId) {
      try {
        const { data } = await pageApi.getPageByParams({
          id: pageId
        })

        this.pageContent = data
      } catch (error) {
        console.error('获取关于页面失败:', error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.subcontent {
  font-size: 16px;
  line-height: 1.8;

  .subbanner {
    background-size: 100% 100%;
  }




  .titleA {
    position: relative;
    font-size: 30px;
    font-weight: bold;
    margin: 20px 0;
    padding: 0;
    color: #000;
    text-indent: 20px;
    ;
  }

  .titleA strong::after {
    display: block;
    content: "";
    width: 6px;
    border-radius: 4px;
    height: 30px;
    background: #004DB8;
    position: absolute;
    left: 0;
    top: 6px;
  }

 h3{
  margin-top:20px;
  display:block;
  span{
    display:inline-block;
    width:16px;
    height:16px;
    margin-right:5px;
    position: relative;
    top:1px;
  }
 }
}

// 移动端适配样式
@media (max-width: 768px) {
  .subcontent {
    font-size: 1rem;
    line-height: 1.6;

    .subbanner {
      
      .container {
        padding-left: 1rem !important;
      }

      .title {
        font-size: 1.8rem !important;
      }

      span {
        font-size: 1.1rem !important;
      }
    }

    .titleA {
      margin: 1rem 0 !important;
      
    }

    .submain {
      padding: 1rem 0 !important;

      .el-row {
        flex-direction: column !important;

        .el-col {
          &:first-child {
            width: 100% !important;
            margin-bottom: 1rem !important;
          }

          &:last-child {
            width: 100% !important;
          }
        }
      }

      p {
        font-size: 0.9rem !important;
        line-height: 1.7 !important;
        margin: 1rem 0 !important;
      }

      h3 {
        font-size: 1.1rem !important;
        margin-top: 1.2rem !important;
        
        span {
          width: 12px !important;
          height: 12px !important;
        }
      }

      img {
        width: 100% !important;
        height: auto !important;
      }
    }
  }
}
</style>